<template>
    <div class="navbar-custom">
        <div class="topbar container-fluid">
            <div class="d-flex align-items-center gap-lg-2 gap-1">

                <!-- Topbar Brand Logo -->
                <div class="logo-topbar">
                    <!-- Logo light -->
                    <a href="index.html" class="logo-light">
                        <span class="logo-lg">
                            <img src="/assets/images/logo.png" alt="logo">
                        </span>
                        <span class="logo-sm">
                            <img src="/assets/images/logo-sm.png" alt="small logo">
                        </span>
                    </a>

                    <!-- Logo Dark -->
                    <a href="index.html" class="logo-dark">
                        <span class="logo-lg">
                            <img src="/assets/images/logo-dark.png" alt="dark logo">
                        </span>
                        <span class="logo-sm">
                            <img src="/assets/images/logo-dark-sm.png" alt="small logo">
                        </span>
                    </a>
                </div>

                <!-- Sidebar Menu Toggle Button -->
                <button @click="toggleMenu" class="button-toggle-menu">
                    <i class="mdi mdi-menu"></i>
                </button>

                <!-- Horizontal Menu Toggle Button -->
                <button class="navbar-toggle" data-bs-toggle="collapse" data-bs-target="#topnav-menu-content">
                    <div class="lines">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>

            </div>

            <ul class="topbar-menu d-flex align-items-center gap-3">
                <li class="dropdown" ref="languageDropdown">
                    <a class="nav-link dropdown-toggle arrow-none" href="#" role="button" @click="collapseLanguage= !collapseLanguage">
                        <img :src="getFlag(selectedLanguage)" alt="user-image" class="me-0 me-sm-1" height="12">
                        <span class="align-middle d-none d-lg-inline-block">{{selectedLanguage}}</span> <i class="mdi mdi-chevron-down d-none d-sm-inline-block align-middle"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated" :class="{show : collapseLanguage}" style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate3d(0.8px, 72px, 0px);">
                        <a href="javascript:void(0);" @click="changeLanguage" class="dropdown-item">
                            <img :src="getFlag(alternativeLanguage)" alt="user-image" class="me-1" height="12"> <span class="align-middle">{{alternativeLanguage}}</span>
                        </a>
                    </div>
                </li>

                <NotificationsNavBar></NotificationsNavBar>

                <li class="d-none d-sm-inline-block">
                    <button type="button" class="nav-link border-0 bg-transparent" id="light-dark-mode"
                        :aria-label="theme === 'dark' ? 'Activar modo claro' : 'Activar modo oscuro'"
                        :aria-pressed="theme === 'dark'" :title="theme === 'dark' ? 'Modo claro' : 'Modo oscuro'"
                        @click="toggleTheme">
                        <i :class="theme === 'dark' ? 'ri-sun-line' : 'ri-moon-line'" class="font-22" aria-hidden="true"></i>
                    </button>
                </li>



                <li class="dropdown" ref="profileDropdown">
                    <a class="nav-link dropdown-toggle arrow-none nav-user px-2" @click="collapseProfile=!collapseProfile" data-bs-toggle="dropdown" href="javascript:void(0);" role="button" aria-haspopup="false" aria-expanded="false" :aria-label="`Perfil de ${nombreUsuario}`">
                        <span class="account-user-avatar" aria-hidden="true">
                            {{ inicialesUsuario }}
                        </span>
                        <span class="d-lg-flex align-items-center d-none">
                            <h5 class="my-0 profile-name" :title="nombreUsuario">{{ nombreUsuario }}</h5>
                        </span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown" :class="{show : collapseProfile}" style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate3d(0.8px, 72px, 0px);">
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">{{ nombreUsuario }}</h6>
                        </div>
                        <!-- item-->
                        <a @click="logout" href="javascript:void(0);" class="dropdown-item">
                            <i class="mdi mdi-logout me-1"></i>
                            <span>{{$t('actions.logout')}}</span>
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, computed } from 'vue'
    import { useI18n } from 'vue-i18n'
    import NotificationsNavBar from './NotificationsNavBar.vue'
    import useAuthStore from '../stores/auth.store';
    import { theme, toggleTheme } from '../theme';

    const authStore = useAuthStore();
    const nombreUsuario = computed(() =>
        String(authStore.usuario?.username || authStore.usuario?.userName || authStore.usuario?.nombre || '').trim() || 'Usuario'
    )
    const inicialesUsuario = computed(() => {
        const partes = nombreUsuario.value.split('@')[0].split(/[\s._-]+/).filter(Boolean)
        return (partes.length > 1
            ? partes[0][0] + partes[partes.length - 1][0]
            : partes[0].slice(0, 2)).toLocaleUpperCase('es-MX')
    })
    const htmlBar = ref(null)
    const collapseLanguage = ref(false)
    const collapseNotification = ref(false)
    const collapseProfile = ref(false)
    const selectedLanguage = ref('Español')
    const alternativeLanguage = computed(() => {
        return selectedLanguage.value == 'Español' ? 'English' : 'Español'
    })
    const {locale} = useI18n({ useScope: 'global' })

    const languageDropdown = ref(null)
    const notificationDropdown = ref(null)
    const profileDropdown = ref(null)


    onMounted(
        () => {
            htmlBar.value = document.getElementById('settings')
            window.addEventListener('click', listener)
        }
    )

    function getFlag(language){
        if(language == 'Español')
            return '/assets/images/flags/spain.jpg'
        else if(language == 'English'){
            return '/assets/images/flags/us.jpg'
        }
    }

    const toggleMenu = () => {
        // alert('toggle menu')
        
        htmlBar.value.classList.toggle('sidebar-enable')
        if( htmlBar.value.dataset.sidenavSize == 'condensed' ) {
            htmlBar.value.dataset.sidenavSize = 'default'
        } else {
            htmlBar.value.dataset.sidenavSize = 'condensed'
        }

    }
    function changeLanguage(){
        selectedLanguage.value=alternativeLanguage.value
        collapseLanguage.value= !collapseLanguage
        if (selectedLanguage.value == 'Español')
            locale.value = 'es'
        else
            locale.value = 'en'
    }

    function listener(e){
        if (collapseLanguage.value && e.target != languageDropdown.value && !e.composedPath().includes(languageDropdown.value)){
            collapseLanguage.value = false
            return
        }
        else if (collapseNotification.value && e.target != notificationDropdown.value && !e.composedPath().includes(notificationDropdown.value)){
            collapseNotification.value = false
            return
        }
        else if (collapseProfile.value && e.target != profileDropdown.value && !e.composedPath().includes(profileDropdown.value)){
            collapseProfile.value = false
            return
        }
        
    }

    const logout = ()=> {
        authStore.logout()
    }


</script>

<style scoped>
.account-user-avatar {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: var(--ct-primary);
    color: #fff;
    font-size: 0.75rem;
    font-weight: 700;
}

.profile-name {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
